<div>
  @switch (loadingState) {
    @case ('in_progress') {
      <loader></loader>
    }
    @case ('loaded') {
      <img [src]="imageSrc" />
    }
    @case ('error') {
      <span class="error-message">The image could not be loaded.</span>
    }
  }
</div>
